export default __webpack_public_path__ + "static/media/christmasCat.900034b4.webp";